import {configureStore, Middleware} from '@reduxjs/toolkit';

import rootReducer from './reducers';
import {cacheListener} from './cacheListener';

import {apis} from './apiRegistry';

export const makeStore = (preloadedState: object | null = null) => {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware()
            .prepend(cacheListener.middleware)
            .concat(apis.map(api => api.middleware) as Middleware[]),
        ...preloadedState ? {preloadedState} : {},
    });
};

export type RootState = ReturnType<typeof rootReducer>;
